var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchimagethankyoupage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 333.32 162.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-3{fill:#fff;}.cls-2{fill:#da00c6;stroke-width:1.01px;}.cls-2,.cls-3{stroke:#000;stroke-miterlimit:10;}.cls-3{stroke-width:2.01px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 14.41,
    width: 286.5,
    height: 95.13,
    rx: 16.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 286.5,
    height: 95.13,
    rx: 16.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 63.42,
    y: 16.05,
    width: 202.97,
    height: 60.14,
    rx: 8
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M97.54,38.84a3.06,3.06,0,1,1,6.1,0,3.05,3.05,0,1,1-6.1,0Zm0,18.09a3.06,3.06,0,1,1,6.1,0,3.05,3.05,0,1,1-6.1,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M106.51,65.75a34.64,34.64,0,0,0,6.46-21c0-9.17-2.76-15.74-6.46-20.81H110c3.28,4.2,6.72,10.76,6.72,20.86S113.28,61.39,110,65.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M156.85,38.84a3.06,3.06,0,1,1,6.1,0,3.05,3.05,0,1,1-6.1,0Zm0,18.09a3.06,3.06,0,1,1,6.1,0,3.05,3.05,0,1,1-6.1,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M165.83,65.75a34.71,34.71,0,0,0,6.45-21c0-9.17-2.76-15.74-6.45-20.81h3.48c3.28,4.2,6.72,10.76,6.72,20.86s-3.44,16.56-6.72,20.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M219.18,38.84a3.06,3.06,0,1,1,6.1,0,3.05,3.05,0,1,1-6.1,0Zm0,18.09a3.06,3.06,0,1,1,6.1,0,3.05,3.05,0,1,1-6.1,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M228.15,65.75a34.71,34.71,0,0,0,6.46-21c0-9.17-2.77-15.74-6.46-20.81h3.49c3.28,4.2,6.71,10.76,6.71,20.86s-3.43,16.56-6.71,20.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.23,58.59l-6.78-8.68a9.22,9.22,0,1,0-2,1.85l6.64,8.52ZM22.84,44.33A6.66,6.66,0,1,1,29.49,51,6.65,6.65,0,0,1,22.84,44.33Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "323.45 161.09 331.91 153.48 303.73 121.58 329.68 112.39 262.16 82.74 282.99 153.01 294.91 130.23 323.45 161.09"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchimagethankyoupage);
export default __webpack_public_path__ + "static/media/searchimagethankyoupage.2fca46abdd78dd4c2d4173353d043b80.svg";
export { ForwardRef as ReactComponent };